import { render, staticRenderFns } from "./QuestionInputText.vue?vue&type=template&id=3d492cd2&scoped=true&"
import script from "./QuestionInputText.vue?vue&type=script&lang=js&"
export * from "./QuestionInputText.vue?vue&type=script&lang=js&"
import style0 from "./QuestionInputText.vue?vue&type=style&index=0&id=3d492cd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d492cd2",
  null
  
)

export default component.exports